<template>
<div class="wrapper">
  <h4>{{ titleName }}</h4>
  <el-form :model="form" ref="form" label-width="100px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item  label="类型编码">
          <el-input v-model="form.typeCode" placeholder="请输入类型编码" auto-complete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item  label="类型名称">
          <el-input v-model="form.typeName" placeholder="请输入类型名称" auto-complete="off"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item  label="类型描述">
          <el-input v-model="form.typeDesc" placeholder="请输入类型描述" auto-complete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item style="text-align: center;">
          <el-button type="primary" icon="fa fa-check" @click="submitEvent('form')">保存</el-button>
          <el-button icon="fa fa-undo" @click="$router.go(-1)">返回</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from "vuex";

export default {
  name: 'AddOrEdit',
  data() {
    return {
      titleName: '',
      form: {},
      tablePage: {
        totalResult: 0,
        currentPage: 0,
        pageSize: 10,
        align: "left",
        pageSizes: [10, 20, 50, 100, 200, 500, 1000],
        perfect: true
      },
	  plateNoId: ''
    }
  },
  computed: {
    routeType() {
      return this.$route.params.type
    },
	searchist() {
	      var list = [];
	      var _list = [];
	      var _this = this;
	      this.seqList.map(function (item) {
	        if (item.plateNo.indexOf(_this.plateNoId) != -1) {
	          //然后把当前json添加到list数组中
	          _list.push(item);
	          list = _list;
	        }
	      });
	      return list;
	    }
  },
  created() {
    this.initView()
  },
  methods: {
    ...mapActions([
      "addDictTypeServe",
    ]),
	focusEvent1() {
	  this.$refs.xDown1.showPanel();
	},
	//获取水泥车数据
	plateNoClick(item) {
	  this.form.plateNoId = item.id;
	  this.plateNoId = item.plateNo;
	  this.$refs.xDown1.hidePanel();
	},
	getLeaveTime(data) {
	  this.form.leaveTime = data;
	},
	getFactTime(data) {
	  this.form.factTime = data;
	},
    initView() {
      if (this.routeType == 'add') {
        this.titleName = '添加字典类型'
      } else {
        this.titleName = '修改字典类型'
        this.itemData = JSON.parse(this.$route.query.item);
        console.log(this.itemData)
        //这里调用请求编辑时的详情接口渲染form表单数据
        this.form = {
          typeCode: this.itemData.typeCode,
          typeName: this.itemData.typeName,
          typeDesc: this.itemData.typeDesc,
          id: this.itemData.id
        }
		this.plateNoId = this.itemData.plate
      }
    },
    //区域选择
    selectArea(data) {
      this.form.teamName = '';
      this.teamByAreaList = '';
      this.getTeamListByArea(data); //获取队伍
    },
    submitEvent() {
      let params = this.form
      this.addDictTypeServe(params).then(res => {
        if (res.code == 200) {
          this.$XModal.message({
            message: '保存成功',
            status: "success"
          });
          this.$router.go(-1)
        }
        this.loading = false;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  h4 {
    height: 40px;
    line-height: 40px;
    color: #F26333;
    padding-left: 20px;
  }

  .vxe-form {
    padding: 25px 0;
    overflow: auto;
  }
  .my-dropdown1 {
      height: 200px;
      overflow: auto;
      border-radius: 4px;
      background-color: #fff;
      border: 1px solid #dcdfe6;
	  padding: 0 8px;
      li {
        height: 32px;
        line-height: 32px;
        cursor: pointer;
      }
    }
}
</style>
